import React, { useEffect, useState } from "react";
import AnnouncementCenter from "./AnnouncementCenter";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { createClient } from "@supabase/supabase-js";
import XPBar from "./XPBar";
// import DailyReward from "./DailyRewards";
import Topbar from "./Topbar";
import Loader from "./Loader";
// import DailyRewardsPass from "./DailyRewardsPass";
import TrophyUnlockModal from "./TrophyUnlockModal";
import Footer from "./Footer";
const apiBase = process.env.REACT_APP_API_URL;
const supabase = createClient(process.env.REACT_APP_SUPABASE_URL, process.env.REACT_APP_SUPABASE_KEY, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});

const regions = [
  {
    code: "LCK",
    name: "LCK",
    color: "28, 25, 44",
    color2: "73, 78, 205",
    banner: "/banners/LCK-banner.png",
    trophyLocked: "/banners/lck-trophy.png",
    trophyUnlocked: "/banners/lck-trophy-clear.png",
  },
  {
    code: "LEC",
    name: "LEC",
    color: "107, 104, 255",
    color2: "0, 229, 190",
    banner: "/banners/LEC-banner.png",
    trophyLocked: "/banners/lec-trophy.png",
    trophyUnlocked: "/banners/lec-trophy-clear.png",
  },
  {
    code: "LPL",
    name: "LPL",
    color: "0, 0, 0",
    color2: "252, 12, 73",
    banner: "/banners/LPL-banner.png",
    trophyLocked: "/banners/lpl-trophy.png",
    trophyUnlocked: "banners/lpl-trophy-clear.png",
  },
  {
    code: "LCP",
    name: "LCP",
    color: "247, 137, 74",
    color2: "0, 0, 0",
    banner: "/banners/LCP-banner.png",
    trophyLocked: "/banners/lcp-trophy.png",
    trophyUnlocked: "banners/lcp-trophy-clear.png",
  },
  {
    code: "FIRST",
    name: "FIRST STAND",
    color: "255, 86, 1",
    color2: "255, 86, 1",
    banner: "/banners/FIRST-banner.png",
  },
  {
    code: "MSI",
    name: "Mid-Season Invitational",
    color: "101, 40, 100",
    color2: "254, 27, 36",
    startDate: "2025-05-15",
    endDate: "2025-06-15",
    banner: "/banners/msi-banner.svg",
    trophyLocked: "/banners/msi-trophy.png",
    trophyUnlocked: "/banners/msi-trophy-clear.png",
  },
  {
    code: "WORLDS",
    name: "World Championship",
    color: "0, 0, 0",
    color2: "21, 97, 255",
    startDate: "2025-10-01",
    endDate: "2025-11-10",
    banner: "/banners/worlds-banner.png",
    trophyLocked: "/banners/worlds-trophy.png",
    trophyUnlocked: "/banners/worlds-trophy-clear.png",
  },
];

export default function CareerPage() {
  const navigate = useNavigate();
  const [career, setCareer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [token, setToken] = useState(null);
  // const [currentIndex, setCurrentIndex] = useState(0);
  const [currentOpen] = useState(false);
  const [trophyQueue, setTrophyQueue] = useState([]);
  const [activeTrophy, setActiveTrophy] = useState(null);

  useEffect(() => {
    const fetchCareerData = async () => {
      try {
        // Get Supabase session
        const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
        if (sessionError || !sessionData.session) throw new Error("User not logged in");

        const accessToken = sessionData.session.access_token;
        setToken(accessToken);
        // Fetch career info
        const res = await axios.get(`${apiBase}/api/career`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });

        setCareer(res.data);

        const trophyRes = await axios.get(`${apiBase}/api/trophies`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });

        if (trophyRes.data.success && trophyRes.data.trophies.length > 0) {
          setTrophyQueue(trophyRes.data.trophies);
          setActiveTrophy(trophyRes.data.trophies[0]);
        }
      } catch (err) {
        console.error("Error loading career:", err);
        setError(err.response?.data?.error || err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCareerData();
  }, []);

  const handleCloseTrophy = async () => {
    if (!activeTrophy) return;

    try {
      // mark current as seen
      await axios.post(`${apiBase}/api/trophies/mark-seen`, { trophyIds: [activeTrophy.id] }, { headers: { Authorization: `Bearer ${token}` } });
    } catch (err) {
      console.error("Failed to mark trophy seen", err);
    }

    // move to next trophy
    const remaining = trophyQueue.slice(1);

    setTrophyQueue(remaining);
    setActiveTrophy(remaining.length > 0 ? remaining[0] : null);
  };

  if (loading) return <Loader loadingTitle={"Loading Career Profile"} />;
  if (error) return <p style={{ color: "#f66", textAlign: "center" }}>Error: {error}</p>;

  return (
    <div className="page-container" style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Topbar showBudget={false} showLinks={false} showEmptyRewards={true} />
      <AnnouncementCenter />
      {activeTrophy && !currentOpen && <TrophyUnlockModal trophy={activeTrophy} onClose={handleCloseTrophy} regions={regions} />}
      {/* <DailyRewardsPass token={token} /> */}
      <div className="main" style={{ display: "flex", alignItems: "center", flexDirection: " column" }}>
        <div className="career-parent">
          {career && (
            <>
              <div style={{ maxWidth: "636px", width: "100%", display: "flex", flexDirection: "column" }} className="career-profile">
                <h2 style={{ margin: "0 0 10px 0", color: "white", textTransform: "uppercase", fontSize: "16px", letterSpacing: "-0.4px" }}>
                  Profile
                </h2>
                <div className="career-profile-details">
                  <div
                    className="career-profile-container"
                    style={{
                      backgroundImage: 'url("/profile-bg.png")',
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}>
                    <img src={`/avatars/${career.profile.profile_image}`} alt="Profile" />
                    <h2>{career.profile.display_name}</h2>
                    <XPBar xp={career.profile.xp || 0} />
                  </div>
                  <div className="career-details">
                    <div className="career-total-trophies">
                      <img src="/trophies-bundle.png" style={{ height: "64px", marginBottom: "6px" }} alt="Region Trophies" />
                      <h4 style={{ color: "white", textAlign: "center", fontSize: "14px" }}>
                        Troph{career.total_trophies === 1 ? "y" : "ies"}
                        <br></br>
                        {career.total_trophies}
                      </h4>
                    </div>
                    {/* <DailyReward /> */}
                  </div>
                </div>
                <div className="career-secondary-row" onClick={() => navigate("/rewards")} style={{ cursor: "pointer" }}>
                  <div
                    className="career-news-snippet"
                    style={{ display: "flex", flexDirection: "column", padding: "0px", background: "none", border: "none" }}>
                    <img
                      src="/first-stand-2026-promo.webp"
                      style={{ width: "100%", objectFit: "contain", borderRadius: "8px" }}
                      alt="First Stand 2026 Collection"
                    />
                  </div>
                </div>
              </div>

              <div className="career-leagues-container">
                <h2 style={{ margin: "0 0 10px 0", color: "white", textTransform: "uppercase", fontSize: "16px", letterSpacing: "-0.4px" }}>
                  Leagues
                </h2>

                <div className="career-leagues">
                  {career.leagues.map((league) => {
                    const handleClick = () => {
                      navigate(`/dashboard/league/${league.id}`);
                    };

                    const derivedRegion =
                      league.region ||
                      league.event_code ||
                      (league.name?.toUpperCase().includes("FIRST") ? "FIRST" : league.name?.toUpperCase().includes("WORLDS") ? "WORLDS" : null);

                    const r = regions.find((reg) => reg.code === derivedRegion) || {
                      color: "50,50,50",
                      color2: "100,100,100",
                    };

                    return (
                      <div
                        key={league.id}
                        className="career-league-single"
                        onClick={handleClick}
                        style={{
                          background: `linear-gradient(200deg, rgba(${r.color2}, 1) 0%, rgba(${r.color}, 1) 80%)`,
                          borderRadius: "8px",
                          padding: "12px 16px",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.02)")}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginBottom: "8px",
                          }}
                          className="career-leagues-header">
                          {r.banner && (
                            <img
                              src={r.banner}
                              alt={`${league.region} banner`}
                              style={{
                                height: "22px",
                                width: "auto",
                                objectFit: "contain",
                              }}
                            />
                          )}

                          <h3
                            style={{
                              margin: 0,
                              color: "#fff",
                              fontSize: "16px",
                              fontWeight: 700,
                              lineHeight: 1,
                            }}>
                            {league.name}
                          </h3>
                        </div>

                        <p style={{ margin: "0", opacity: 0.8, color: "white", textAlign: "center" }}>
                          {league.region || league.event_code} • {league.split_type || "Split"}
                        </p>
                        {/* <p
                          style={{
                            margin: "8px 0 0",
                            fontSize: "0.9em",
                            color: "#ccc",
                          }}>
                          Weeks {league.start_week}–{league.end_week}
                        </p> */}
                        {league.invite_code ? (
                          <h3 style={{ margin: "10px 0 0 0", color: "white", textAlign: "center" }}>
                            {typeof league.invite_code === "object" ? league.invite_code.code : league.invite_code}
                          </h3>
                        ) : null}

                        {league.trophies_earned > 0 && (
                          <p style={{ margin: "8px 0 0", fontSize: "0.9em", color: "#ffd700" }}>
                            {league.trophies_earned} Trophy
                            {league.trophies_earned > 1 ? "ies" : ""}
                          </p>
                        )}
                      </div>
                    );
                  })}

                  {/* Add empty placeholders */}
                  {Array.from({ length: Math.max(0, 8 - career.leagues.length) }).map((_, i) => {
                    const handleClick = () => {
                      navigate(`/choose-region`);
                    };
                    return (
                      <div key={`empty-${i}`} className="career-league-single empty-slot" onClick={handleClick}>
                        <p style={{ opacity: 0.6, margin: "5px", fontSize: "14px" }}>Empty Slot</p>
                        <p style={{ opacity: 0.3, fontSize: "14px", margin: "0" }}>Click to join a new league</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
